





































import changeLogMixin from '@adobe/edex/frontend/views/course/settings/mixin';
import { checkObjectArrayDiff, getID } from '@adobe/edex/frontend/views/course/settings/constants';
import SelectCard from '@adobe/edex/frontend/views/course/settings/course-settings-select-card.vue';

const MODAL_WIDTH = 656;
const getInitialState = initialCourse => ({
  credlyBadges: initialCourse.credlyBadges,
});

export default {
  mixins: [changeLogMixin],
  props: {
    initialCourse: {
      type: Object,
      required: true,
    },
  },
  data() {
    return getInitialState(this.initialCourse);
  },
  components: {
    SelectCard,
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    getAvatarStyle(avatarURL) {
      return { backgroundImage: `url(${avatarURL})`, };
    },
    onMetaChanged({ name, data }) {
      this[name] = data;
    },
    resetChanges() {
      Object.assign(this.$data, getInitialState(this.initialCourse));
    },
  },
  watch: {
     credlyBadges(current, previous) {
      if (previous !== current) {
        this.onChange({
          name: 'badges',
          data: current.map(getID),
          hasDiff: checkObjectArrayDiff(this.initialCourse.credlyBadges, current),
        });
      }
    },
  },
};
